<template>
  <div
    :class="{'accordion__item--active': visible}"
    class="accordion__item rounded-3xl transition-shadow duration-500"
  >
    <div
      class="accordion__trigger px-8 py-6 lg:p-8 font-600"
      :class="{'accordion__trigger_active': visible}"
      @click="open"
    >
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-trigger" />

      <div>
        <svg
          v-if="!visible"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          width="24"
        ><path
          fill="#0A4154"
          d="m14.2 11.8 3.9.3c-.1.2-4-.1-4 0H13l-.5.2-.2.7c-.5 1.6-.8 3.3-1 5-.2.7-.2 1.4 0 2.1v.4c-.2.1-.4 0-.6-.1A9 9 0 0 0 9.6 19c-.3 0-.2.4-.4.5l-.2-.1a5 5 0 0 1-.9-2.5c0-1 .2-2 .4-3l.2-1.3c0-.3-.3-.3-.5-.3h-1c-.2 0-.5-.1-.7-.4l1-.1c.6 0 1 0 1.5-.2l-.3-.2H6.5c-.4 0-.8-.2-1.1-.4l-.6-.3c-.3 0-.5-.3-.7-.6-.2-.2 0-.7.3-.8l.8-.1h3.5l.9-.2c0-.3.2-.6.3-.8a41.2 41.2 0 0 1 1.8-4.6c.1-.2.4-.2.6-.1.5.2.9.6.9 1.1.3.1.7.1.8.4.2.2.2.6.2.9-.1.5-.3 1.1-.3 1.7-.2.3-.3.7-.3 1 .4.2 5.6 0 6-.1l.7.5.2.2c.2.1-.7.1-.5.4.2.3.6.6.6 1-.4.4-.9.4-1.3.5h-5.6l-.9.3h6.3l1.2-.3-.1.3-1 .3-.2.3-4.8-.2Z"
        /></svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          width="24"
        ><path
          fill="#0A4154"
          d="m14.2 11.8 3.9.3c-.1.2-4-.1-4 0H13l-.5.2H7.2c-.2 0-.5-.1-.7-.4l1-.1c.6 0 1 0 1.5-.2l-.3-.2H6.5c-.4 0-.8-.2-1.1-.4l-.6-.3c-.3 0-.5-.3-.7-.6-.2-.2 0-.7.3-.8l.8-.1h3.5c3.6 0 7.4-.3 11-.7l.6.5.2.2c.2.1-.7.1-.5.4.2.3.6.6.6 1-.4.4-.9.4-1.3.5h-5.6l-.9.3h6.3l1.2-.3-.1.3-1 .3-.2.3-4.8-.2Z"
        /></svg>
      </div>
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div
        v-show="visible"
        class="accordion__content"
      >
        <div class="px-8 pb-8">
          <!-- This slot will handle all the content that is passed to the accordion -->
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {},
  inject: ["AccordionGroup"],
  data () {
    return {
      index: null
    }
  },
  computed: {
    visible () {
      return this.index === this.AccordionGroup.active
    }
  },
  created () {
    // console.log(this.AccordionGroup)
    this.index = this.AccordionGroup.count++
  },
  methods: {
    open () {
      if (this.visible) {
        this.AccordionGroup.active = null
      } else {
        this.AccordionGroup.active = this.index
      }
    },
    start (el) {
      el.style.height = el.scrollHeight + "px"
    },
    end (el) {
      el.style.height = ""
    }
  }
}
</script>

<style lang="css">
.accordion__item {
  cursor: pointer;
  position: relative;
  box-shadow: 0 0 0 0px #F8F5F2;
}

.accordion__item--active,
.accordion__item:hover {
    box-shadow: 0 0 0 10px #F8F5F2;
}

.accordion__trigger {
  display: flex;
  justify-content: space-between;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
